module.exports = __webpack_public_path__ + "static/media/aptoMedico.91935459.pdf";